import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Button,  TextField}from '@material-ui/core';

import SearchIcon from '@material-ui/icons/Search';

import commonStyles from '../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    button: {
      width: '100px',
      height: '40px'
    },
    disabled: {
      color: 'rgba(0, 0, 0, 0.26)'
    },
    helperText: {
      color: 'red'
    },
    '@media (max-width: 1024px)': {
      wrapper: {
      right: '50px',
      left: 'auto'
      },
    },
    '@media (max-width: 680px)': {
      wrapper: {
        right: 'auto',
        left: '25px',
        top: '90px',
        zIndex: 1,
      },
    },
    '@media (max-width: 480px)': {
      wrapper: {
        right: 'auto',
        left: '15px !important',
        top: '90px',
        zIndex: 1,
      },
    },
  });

interface WhsOrderSearchProps {
  classes: any;
  keyword: string;
  errorKeyword: boolean;
  handleChangeKeyword: (event: any) => void;
  search: () => void;
};

const whsOrderSearch = (props: WhsOrderSearchProps) => {

  const {  keyword, classes, errorKeyword } = props;

  return (
        <div className={ [classes.search].join(" ")}>
          <TextField
            value={ keyword }
            variant="outlined"
            onChange={ props.handleChangeKeyword }
            error={ errorKeyword }
            helperText= {errorKeyword ? 'Enter more than 3 characters': ''}
            className={ commonStyles.searchWrapper } 
            InputProps={{ 
              className: commonStyles.searchIpField,
            }}
            InputLabelProps={{
              className: classes.textFieldLabel,
              shrink: false
            }}
            placeholder='Order or AWB'
          />

          <Button  
            color="primary" 
            variant="contained"
            onClick={ props.search } 
            className={commonStyles.searchBtn}
          >
          <SearchIcon className={commonStyles.iconSearch}/>
          </Button>

        </div>
  )
};

export default withStyles(styles)(whsOrderSearch);